import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import PublicationPageContainer from './publication_page_container';
// import PublicationPage from './PublicationPage';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: "auto",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));



export default function SimpleModal({ 
    closeModal, modalTitle, setPreviewImage, previewImage, steps, setInfoChecksRequirement, 
    infoChecksRequirement, updatePublicationPage, publicationPage, workInstruction, toggleRelease, setTitle, title, setPreviewImages,backToWIList, saveWorkInstruction,WIPID}) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    return (
        <Modal
            open={true}
            onClose={closeModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "85vw",
                maxWidth: "1200px",
                height: "85vh",
                maxHeight: "95vh",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden"
            }} className={classes.paper}>
                <div className="flex-apart">
                    <h2 id="simple-modal-title">{modalTitle}</h2>
                    <div className="flex-centered clickable" onClick={closeModal}>
                        <p style={{marginRight: '.5em'}}>Close Window</p>
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 0C5.5875 0 0 5.5875 0 12.5C0 19.4125 5.5875 25 12.5 25C19.4125 25 25 19.4125 25 12.5C25 5.5875 19.4125 0 12.5 0ZM12.5 22.5C6.9875 22.5 2.5 18.0125 2.5 12.5C2.5 6.9875 6.9875 2.5 12.5 2.5C18.0125 2.5 22.5 6.9875 22.5 12.5C22.5 18.0125 18.0125 22.5 12.5 22.5ZM16.9875 6.25L12.5 10.7375L8.0125 6.25L6.25 8.0125L10.7375 12.5L6.25 16.9875L8.0125 18.75L12.5 14.2625L16.9875 18.75L18.75 16.9875L14.2625 12.5L18.75 8.0125L16.9875 6.25Z" fill="#10396A" />
                        </svg>
                    </div>
                </div>
                <div style={{flex: 1, minHeight: 0, overflowY: "auto", marginTop: '15px', paddingRight: '8px'}} className="modal-content">
                    <PublicationPageContainer
                        closeModal={closeModal}
                        toggleRelease={toggleRelease}
                        setTitle={setTitle}
                        previewImage={previewImage}
                        steps={steps}
                        backToWIList={backToWIList}
                        setPreviewImages={setPreviewImages}
                        setInfoChecksRequirement={setInfoChecksRequirement}
                        infoChecksRequirement={infoChecksRequirement}
                        setPreviewImage={setPreviewImage}
                        updatePublicationPage={updatePublicationPage}
                        publicationPage={publicationPage}
                        workInstruction={workInstruction}
                        title={title}
                        saveWorkInstruction={saveWorkInstruction}
                        WIPID={WIPID}
                    />
                </div>
                {/* <div className="max-width flex-centered" style={{height:"7%"}}>
                    <button onClick={() => handleButtonClick(closeModal, toggleRelease)} id="confirmation-button">Release Work Instruction</button>
                </div> */}
            </div>
        </Modal>
    );
}
